"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectUtil = void 0;
const lodash_1 = require("lodash");
const JsonUtil_1 = require("../../base/cutil/JsonUtil");
const StudioProject_1 = require("../../base/project/domain/StudioProject");
const StoryUtil_1 = require("../../base/storyV2/domain/StoryUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class ProjectUtil {
    static findSourceNodes(edgeId, nodes) {
        const edge = nodes.find(e => e.id === edgeId);
        if (!edge) {
            return [];
        }
        const edgeData = edge.data;
        const flows = edgeData.flows;
        if (!flows) {
            return [];
        }
        const sourceNodeIds = flows.map(f => f.sourceNodeId || "").filter(id => id !== "");
        const sourceNodes = nodes.filter(n => {
            return sourceNodeIds.includes(n.id);
        });
        return sourceNodes;
    }
    static sourceNodesAllFill(edgeId, nodes) {
        const sourceNodes = this.findSourceNodes(edgeId, nodes);
        const emptyNodes = sourceNodes.filter(n => {
            const data = n.data;
            return n?.type !== "customGroup" && (0, lodash_1.isEmpty)(data.textAreaValue);
        });
        return emptyNodes.length === 0;
    }
    static transfromStory(selectedTemplate, edges, variableList, getSaveData) {
        const templateObj = selectedTemplate;
        const data = getSaveData(templateObj, edges, variableList, {}, undefined);
        const projectObj = { attributes: data, attrIndexer: data.index, id: templateObj.id };
        const projectJsonStr = JsonUtil_1.JsonUtil.stringify(projectObj);
        const project = JsonUtil_1.JsonUtil.toModelFromType(StudioProject_1.StudioProject, projectJsonStr);
        if (!project) {
            return undefined;
        }
        const story = StoryUtil_1.StoryUtil.from(project, true);
        return story;
    }
    static emptyInput(selectedTemplate, edges, variableList, getSaveData) {
        const story = this.transfromStory(selectedTemplate, edges, variableList, getSaveData);
        if (!story) {
            return true;
        }
        const startNodesWithEdge = story.startNodes.filter(n => {
            return n.edges().length !== 0;
        });
        const emptyNodes = startNodesWithEdge.filter(n => {
            return (0, is_blank_1.default)(n.content) && n.children.length === 0;
        });
        return emptyNodes.length !== 0;
    }
    static findNodes(nodes, inputNodeId, result = []) {
        const foundNodes = nodes.filter((node) => {
            return node.data.flows && node.data.flows.some((flow) => flow.sourceNodeId === inputNodeId);
        });
        if (foundNodes.length > 0) {
            result.push(...foundNodes);
            foundNodes.forEach((foundNode) => {
                const nextNodeId = foundNode.data.targetNodeId;
                this.findNodes(nodes, nextNodeId, result);
            });
        }
        return result;
    }
    // add data source的参数是否为空
    static emptyAddDataSourceParams(nodes, inputNodes, isFromPreview = false) {
        let findNodes = nodes;
        if (inputNodes && isFromPreview) {
            findNodes = [];
            const inputEdgeNodes = inputNodes.map((inputNode) => {
                const inputNodeId = inputNode.id;
                return this.findNodes(nodes, inputNodeId);
            });
            findNodes = inputEdgeNodes?.flat();
        }
        return findNodes.some((node) => {
            const lineParam = node?.data?.lineParam;
            return (lineParam?.enterText === "/Add Data Source" &&
                (0, is_blank_1.default)(lineParam?.requestParam?.file) &&
                (0, is_blank_1.default)(lineParam?.requestParam?.urls));
        });
    }
    /// node右边有直接关联的元素
    /// 返回与之有关的 line -> edge -> line的id
    static nodeRightRelations(nodeId, allNodes, allLines) {
        const directLines = allLines.filter(line => {
            return line.source === nodeId;
        });
        const directLineIds = directLines.map(line => {
            return line.id;
        });
        const directEdgeIds = directLines.map(line => {
            return line.target;
        });
        const lineIdsFromEdges = allLines
            .filter(line => {
            return directEdgeIds.includes(line.source);
        })
            .map(line => {
            return line.id;
        });
        const allIds = [...directLineIds, ...directEdgeIds, ...lineIdsFromEdges];
        return allIds.filter(id => {
            return id !== undefined && id !== "";
        });
    }
}
exports.ProjectUtil = ProjectUtil;
